// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"b25acede","410":"4faeafcd","412":"819900d6","580":"6147e23e","593":"d7d37d39","701":"ef96cae6"}[chunkId] + ".chunk.js";
};